import React, { useContext, useEffect, useState } from 'react';
import { Search, Filter } from 'lucide-react';
import { AppContext } from '../../context/AppContext';
import { PostCallWithErrorResponse } from '../../api/ApiServices';
import ApiConfig from '../../api/ApiConfig';

const TrialBalancePage = () => {
  const { sidebar } = useContext(AppContext);
  const [filterText, setFilterText] = useState('');
  const [showFilter, setShowFilter] = useState(false);
  const [trialBalance, setTrialBalance] = useState({});

  const data = trialBalance?.Accounts?.filter(row =>
    row.AccountName?.toLowerCase().includes(filterText?.toLowerCase())
  );

  const totalDebit = data?.reduce((sum, item) => sum + item.DebitAmount, 0);
  const totalCredit = data?.reduce((sum, item) => sum + item.CreditAmount, 0);
  const isOutOfBalance = totalDebit !== totalCredit;

  const getTrialBalance = () => {
    PostCallWithErrorResponse(ApiConfig.GET_TRIAL_BALANCE, JSON.stringify({})).then((res) => {
      if (res?.json?.Success) setTrialBalance(res?.json?.Data);
    });
  };

  useEffect(() => {
    getTrialBalance();
  }, []);

  return (
    <main className={sidebar ? "taskMain" : "cx-active taskMain"} id="cx-main">
      <div id="sales-main">
        <section className="cx-inneer-header">
          <div className="main-inner">
            <div className="left">
              <label>Trial Balance</label>
            </div>
          </div>
        </section>

        <section className="mt-3">
          <div className="card border-0 overflow-hidden" style={{ borderRadius: '10px', boxShadow: '0 4px 6px -1px rgba(0,0,0,0.1)' }}>
            {/* Header */}
            <div className="card-body border-bottom d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-1 fw-bold">Trial Balance</h4>
                <p className="text-muted mb-0" style={{ fontSize: '0.875rem' }}>Unadjusted</p>
              </div>
              <div className="d-flex align-items-center gap-2">
                {showFilter && (
                  <div className="position-relative">
                    <Search size={14} className="position-absolute top-50 translate-middle-y ms-2 text-muted" style={{ left: 0 }} />
                    <input
                      type="text"
                      className="form-control form-control-sm ps-4"
                      placeholder="Search account..."
                      value={filterText}
                      onChange={(e) => setFilterText(e.target.value)}
                      autoFocus
                    />
                  </div>
                )}
                <button
                  className={`btn btn-sm ${showFilter ? 'btn-primary' : 'btn-outline-secondary'} d-flex align-items-center gap-1`}
                  onClick={() => { setShowFilter(!showFilter); if (showFilter) setFilterText(''); }}
                >
                  <Filter size={14} /> {showFilter ? 'Hide Filter' : 'Filter View'}
                </button>
              </div>
            </div>

            <div className="table-responsive">
              <table className="table table-hover mb-0 align-middle">
                <thead className="table-light">
                  <tr>
                    <th className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.75rem' }}>Acct Code</th>
                    <th className="text-muted text-uppercase fw-bold" style={{ fontSize: '0.75rem' }}>Account Name</th>
                    <th className="text-muted text-uppercase fw-bold text-end" style={{ fontSize: '0.75rem' }}>Debit</th>
                    <th className="text-muted text-uppercase fw-bold text-end" style={{ fontSize: '0.75rem' }}>Credit</th>
                  </tr>
                </thead>
                <tbody>
                  {data?.length > 0 ? (
                    data?.map((row, idx) => (
                      <tr key={idx}>
                        <td className="text-muted font-monospace" style={{ fontSize: '0.875rem' }}>{row?.AccountCode}</td>
                        <td className="fw-medium" style={{ fontSize: '0.875rem' }}>{row?.AccountName}</td>
                        <td className="text-end font-monospace text-secondary" style={{ fontSize: '0.875rem' }}>{row?.DebitAmount > 0 ? row?.DebitAmount : '—'}</td>
                        <td className="text-end font-monospace text-secondary" style={{ fontSize: '0.875rem' }}>{row?.CreditAmount > 0 ? row?.CreditAmount : '—'}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="4" className="p-5 text-center text-muted bg-light" style={{ fontSize: '0.875rem' }}>
                        No accounts found matching "<strong>{filterText}</strong>"
                      </td>
                    </tr>
                  )}
                </tbody>
                <tfoot className="fw-bold" style={{ backgroundColor: isOutOfBalance ? '#fff1f2' : '#f8fafc', borderTop: '2px solid #e2e8f0' }}>
                  <tr>
                    <td colSpan={2} style={{ fontSize: '0.875rem' }}>
                      Totals {filterText && <span className="text-primary ms-1">(Filtered View)</span>}
                    </td>
                    <td className="text-end font-monospace" style={{ fontSize: '0.875rem', color: isOutOfBalance ? '#e11d48' : '#1e293b' }}>{totalDebit}</td>
                    <td className="text-end font-monospace" style={{ fontSize: '0.875rem', color: isOutOfBalance ? '#e11d48' : '#1e293b' }}>{totalCredit}</td>
                  </tr>
                </tfoot>
              </table>
            </div>

            {isOutOfBalance && (
              <div className="p-2 text-center fw-bold text-uppercase text-white" style={{ backgroundColor: '#e11d48', fontSize: '0.75rem' }}>
                Warning: Trial Balance is not equal (Difference: {totalDebit - totalCredit})
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  );
};

export default TrialBalancePage;
